import React, { useContext, useState } from "react";
import SidebarContext from "../../components/Sidebar/SidebarContext";
import IntegrationConfigForm from "./IntegrationConfigForm";
import IntegrationTestModal from "./IntegrationTestModal";

const CONNECTION_GROUPS = ["connection", "advanced"];

/**
 * Third tab of the setup wizard — the actual endpoint/headers/params (plus
 * the data-request proxy, distinct from the auth-request proxy on the
 * Authentication tab). Test Connection fires the real request; the backend
 * always validates auth first regardless (see IntegrationService.invokeIntegration),
 * so a failing auth test on the previous tab will surface here too if skipped.
 */
const IntegrationConnectionPage = ({ template }) => {
    const { entity, emittedData, onSave } = useContext(SidebarContext);
    const [showTest, setShowTest] = useState(false);

    const canTest = !!(entity?.id || emittedData?.integration_key);
    const testButtonTitle = canTest
        ? "Send a test request using the current configuration"
        : "Select an integration template first";

    return (
        <div>
            {template && <IntegrationConfigForm schema={template.config_schema} groups={CONNECTION_GROUPS} />}

            <div className="d-flex justify-content-end px-3 pb-3">
                <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    disabled={!canTest}
                    title={testButtonTitle}
                    onClick={() => setShowTest(true)}
                >
                    <i className="fa fa-bolt me-1" />Test Connection
                </button>
            </div>

            <IntegrationTestModal
                show={showTest}
                onHide={() => setShowTest(false)}
                onConnect={onSave}
                integrationData={{ id: entity?.id, ...emittedData }}
            />
        </div>
    );
};

export default IntegrationConnectionPage;
